module.exports = __webpack_public_path__ + "static/media/TWO.f1b7a5a6.png";